import { JSONContent } from '@tiptap/core';

import { InquisitiveActivitiesResponseVariant } from 'global/constants';

export type DragId = string;

export type InteractiveDragItem = {
  id: DragId;
  el: HTMLDivElement | null;
};

export type DropZone = {
  dragItemId: DragId | null;
  previewItemId: DragId | null;
  isCorrect?: boolean;
};

export type DropItem = {
  id: string;
  label: string;
  zones: DropZone[];
};

export type DragItem = {
  id: string;
  value: string;
  isDropped: boolean;
  question: {
    text: string | null;
    richtext: JSONContent | null;
    audioUrl: string | null;
    baseColour: string | null;
    variant: InquisitiveActivitiesResponseVariant | null;
    image: {
      itemId: string;
      description: string;
      small: string | null;
      large: string | null;
      isFit: boolean;
    } | null;
  };
};

export const PICKUP = 'pickup';
export const CANCELLED = 'cancelled';
export const PLACED = 'placed';
export const MOVE_LEFT = 'moveLeft';
export const MOVE_RIGHT = 'moveRight';

export const INTERACTIVE_DRAG_DROP = 'interactive-drag-drop';
export const INTERACTIVE_CONTAINER_ID = 'interactive-container';
export const INTERACTIVE_CANVAS_ID = 'interactive-canvas';

export type KeyboardInteractionAction =
  | typeof PICKUP
  | typeof CANCELLED
  | typeof MOVE_LEFT
  | typeof MOVE_RIGHT
  | typeof PLACED;

export type KeyboardInteraction = {
  id: DragId;
  action: KeyboardInteractionAction;
  announce: string;
};
